'use client';
import { makeClientEnv } from '@lamesarv-sdk/env/client';
import { ClientEnv } from '.';

export const { EnvProvider, useEnv } = makeClientEnv<ClientEnv>();
